// extracted by mini-css-extract-plugin
module.exports = {"icon":"HiddenStatisticsIcon__icon__10_lN","isLarger":"HiddenStatisticsIcon__isLarger__3E8Sg"};